<template>
  <div class="spec-container">
    <a-spec-group v-for="(spec, index) in specList" :spec="spec" :isClicked="isClicked"
      v-model="specList[index].selectedItem" @update:modelValue="(val) => onColorClick(spec.name, val)"
      @disabled-color-click="onDisabledColor" :key="index">
    </a-spec-group>
    <div class="spec-btns">
      <ap-button type="primary" size="small" v-show="!submitSatus" @click="onClick"
        :disabled="isDisabled">Continue</ap-button>
      <img src="https://img66.anypromo.com/frontimg/2023/Icon/loader.gif" alt="" class="submit-loading"
        v-show="submitSatus" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import ASpecGroup from '../spec/specGroup.vue'
import { type SpecGroup, type SpecItem } from '../../types'
import { ApButton } from '@anypromo/components-pc'
import { computed, defineComponent, inject, ref } from 'vue'
import { SHOW_PRICE_GROUP_KEY } from '../../token'
import { useSpec } from '../../store/modules/spec'

const props = withDefaults(
  defineProps<{
    submitSatus: boolean
  }>(),
  {
    submitSatus: false,
  }
)

const emit = defineEmits(['go-next', 'update-view'])
const specState = useSpec()

const isDisabled = ref(false)

const isClicked = ref(false)

const specList = computed(() => specState.getSelectedList)

const showPriceGroup = inject(SHOW_PRICE_GROUP_KEY)
if (!showPriceGroup) {
  console.warn('build error')
}

const isValidGroup = () => {
  const isValid = specList.value.every((val) => {
    return !!val.selectedItem
  })
  // bus.emit('spec-validate')
  return isValid
}

const onClick = () => {
  isClicked.value = true
  const isValid = isValidGroup()
  isDisabled.value = !isValid
  if (isDisabled.value) {
    return
  }
  emit('go-next')
}

const onColorClick = async (name: string, val: SpecItem | undefined) => {
  if (isClicked.value) {
    const isValid = isValidGroup()
    isDisabled.value = !isValid
  }
  emit('update-view')
}

const onDisabledColor = (group: SpecGroup, color: SpecItem) => {
  if (showPriceGroup) {
    showPriceGroup({
      type: 'spec',
      value: {
        name: group.name,
        value: color.value,
        text: color.text
      }
    }).then((data) => {
      if (data) {

      }
    })
  }
}
</script>
<style lang="less">
.spec-container {
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
}

.spec-btns {
  padding: 0;
  margin: 15px 0;
}
</style>
